module.exports = __webpack_public_path__ + "img/SLE.ccd950bf.svg";